import React, { useState } from "react";
import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineMessage,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../styles/styles";
import { act } from "react-dom/test-utils";

const ProductDetails = ({ data }) => {
  console.log(data);
  const [count, setCount] = useState(1);
  const [click, setClick] = useState(false);
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();

  const incrementCount = () => {
    setCount(count + 1);
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handleMessageSubmit = async () => {};

  return (
    <div className="bg-white">
      {data ? (
        <div className={`${styles.section} w-[70%] 800px:w-[80%]`}>
          <div className="w-full py-5">
            <div className="block w-full 800px:flex">
              <div className="w-full 800px:w-[50%]">
                <img
                  src={data.image_Url[select].url}
                  alt=""
                  srcset=""
                  className="w-[80%]"
                />
                <div className="w-full flex">
                  <div
                    className={`${
                      select === 0 ? "border" : null
                    } cursor-pointer`}
                  >
                    <img
                      src={`${data?.image_Url[0].url}`}
                      alt=""
                      className="h-[200px]"
                      onClick={() => setSelect(0)}
                    />
                  </div>

                  <div
                    className={`${
                      select === 1 ? "border" : null
                    } cursor-pointer`}
                  >
                    <img
                      src={`${data?.image_Url[1].url}`}
                      alt=""
                      className="h-[200px]"
                      onClick={() => setSelect(1)}
                    />
                  </div>
                </div>
              </div>
              <div className="w-full 800px:w-[50%]">
                <h1 className={`${styles.productTitle}`}>{data.name}</h1>
                <p>{data.description}</p>
                <div className="flex pt-3">
                  <h4 className={`${styles.productDiscountPrice}`}>
                    {data.discount_price}$
                  </h4>
                  <h3 className={`${styles.price}`}>
                    {data.price ? data.price + "$" : null}
                  </h3>
                </div>

                <div className="flex items-center mt-12 justify-between pr-3">
                  <div>
                    <button
                      className="bg-gradient-to-r from-teal-400 to-teal-500 text-white font-bold rounded-l px-4 py-2 shadow-lg hover:opacity-75 transition duration-300 ease-in-out"
                      onClick={decrementCount}
                    >
                      -
                    </button>

                    <span className="bg-gray-200 text-gray-800 font-medium px-4 py-[11px]">
                      {count}
                    </span>
                    <button
                      className="bg-gradient-to-r from-teal-400 to-teal-500 text-white font-bold rounded-l px-4 py-2 shadow-lg hover:opacity-75 transition duration-300 ease-in-out"
                      onClick={incrementCount}
                    >
                      +
                    </button>
                  </div>
                  <div>
                    {click ? (
                      <AiFillHeart
                        size={30}
                        className="cursor-pointer"
                        color={click ? "red" : "#333"}
                        title="Remove from wishlist"
                      />
                    ) : (
                      <AiOutlineHeart
                        size={30}
                        className="cursor-pointer"
                        color={click ? "red" : "#333"}
                        title="Add to wishlist"
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`${styles.button} !mt-6 !rounded !h-11 flex items-center`}
                >
                  <span className="text-white flex items-center">
                    Add to cart <AiOutlineShoppingCart className="ml-1" />
                  </span>
                </div>
                <div className="flex items-center pt-8">
                  <Link to={`/shop/preview/${data?.shop._id}`}>
                    <img
                      src={`${data?.shop?.shop_avatar?.url}`}
                      alt=""
                      className="w-[50px] h-[50px] rounded-full mr-2"
                    />
                  </Link>

                  <div className="pr-8">
                    <Link to={`/shop/preview/${data?.shop._id}`}>
                      <h3 className={`${styles.shop_name} pb-1 pt-1`}>
                        {data.shop.name}
                      </h3>
                    </Link>
                    <h5 className="pb-3 text-[15px]">
                      ({data.shop.ratings}/5) Ratings
                    </h5>
                  </div>
                  <div
                    className={`${styles.button} bg-[#6443d1] mt-4 !rounded !h-11`}
                    onClick={handleMessageSubmit}
                  >
                    <span className="text-white flex items-center">
                      Send Message <AiOutlineMessage className="ml-1" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ProductDetailsInfo
            data={data}/>
            <br />
            <br />
        </div>
      ) : null}
    </div>
  );
};

const ProductDetailsInfo=({data})=>{
  const [active, setActive] = useState(1);
  return (
    <div className="bg-[#f5f6fb] px-3 800px:px-10 py-2 rounded ">
      <div className="w-full flex justify-between border-b pt-10 pb-2">
        <div className="relative">
          <h5
            className="text-[#000] text-[18px] px-1 leading-5 font-[600] cursor-pointer 800px:text-[20px]"
            onClick={() => setActive(1)}
          >
            Product Details
          </h5>

          {active === 1 ? (
            <div className={`${styles.active_indicator}`}></div>
          ) : null}
        </div>
        <div className="relative">
          <h5
            className="text-[#000] text-[18px] px-1 leading-5 font-[600] cursor-pointer 800px:text-[20px]"
            onClick={() => setActive(2)}
          >
            Product Reviews
          </h5>

          {active === 2 ? (
            <div className={`${styles.active_indicator}`}></div>
          ) : null}
        </div>
        <div className="relative">
          <h5
            className="text-[#000] text-[18px] px-1 leading-5 font-[600] cursor-pointer 800px:text-[20px]"
            onClick={() => setActive(3)}
          >
            Seller Information
          </h5>

          {active === 3 ? (
            <div className={`${styles.active_indicator}`}></div>
          ) : null}
        </div>
      </div>
      {active === 1 ? (
        <>
          <p className="py-2 text-[18px] leading-8 pb-10 whitespace-pre-line">
           Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facere, perspiciatis ex. Laborum, nostrum delectus! Ipsum sit, et exercitationem molestias fugit quaerat vero alias. Nostrum quia nemo soluta voluptatibus amet dolores.
          </p>
          <p className="py-2 text-[18px] leading-8 pb-10 whitespace-pre-line">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse debitis hic amet eligendi laborum aut obcaecati voluptatum? Voluptates explicabo, quo magni commodi ipsam ut, maiores vero praesentium placeat eligendi quidem?</p>
      
            <p className="py-2 text-[18px] leading-8 pb-10 whitespace-pre-line">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse debitis hic amet eligendi laborum aut obcaecati voluptatum? Voluptates explicabo, quo magni commodi ipsam ut, maiores vero praesentium placeat eligendi quidem?</p>
        </>
      ) : null}

      {active === 2 ?(
         <div className="w-full justify-center min-h-[40vh] flex items-center">
          <p>No Reviews yet</p>
         </div>
      ) : null}


   {active === 3 &&(
         <div className="w-full block 800px:flex p-5">
         <div className="w-full 800px:w-[50%]">
           
             <div className="flex items-center">
               <img
                 src={`${data?.shop?.shop_avatar?.url}`}
                 className="w-[50px] h-[50px] rounded-full"
                 alt=""
               />
               <div className="pl-3">
                 <h3 className={`${styles.shop_name}`}>{data.shop.name}</h3>
                 <h5 className="pb-2 text-[15px]">
                   ({data?.shop?.ratings}) Ratings
                 </h5>
               </div>
             </div>
           
           <p className="pt-2">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Sint harum dolores voluptatum quisquam molestias tenetur nihil dolorum velit unde quos aut, reiciendis amet assumenda inventore, error totam quae pariatur ipsum.</p>
         </div>
         <div className="w-full 800px:w-[50%] mt-5 800px:mt-0 800px:flex flex-col items-end">
           <div className="text-left">
             <h5 className="font-[600]">
               Joined on: <span className="font-[500]">14 march 2023</span>
               <span className="font-[500]">
                 {data.shop?.createdAt?.slice(0, 10)}
               </span>
             </h5>
             <h5 className="font-[600] pt-3">
               Total Products:{" "}
               <span className="font-[500]">
                1,2023
               </span>
             </h5>
             <h5 className="font-[600] pt-3">
               Total Reviews:{" "}
               <span className="font-[500]">324</span>
             </h5>
             <Link to="/">
             <div
                 className={`${styles.button} !rounded-[4px] !h-[39.5px] mt-3`}
               >
                 <h4 className="text-white">Visit Shop</h4>
               </div>
             </Link>
              
             
           </div>
         </div>
       </div>
      ) }
    </div>
  );
}

export default ProductDetails;
